import React from 'react'

import classnames from 'classnames'

import { withStyles } from '@material-ui/core/styles'

import { green, amber } from '@material-ui/core/colors'

import { IconButton, Snackbar, SnackbarContent } from '@material-ui/core'

const systemMessageVariantIcons = {
  success: 'check_circle',
  error: 'error',
  info: 'info',
  warning: 'warning'
}

const systemMessageStyles = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
})

function SystemMessageSnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props

  return (
    <SnackbarContent
      className={classnames(classes[variant], className)}
      message={
        <span className={classes.message}>
          <span className={classes.iconVariant + ' material-icons md-24'}>
            {systemMessageVariantIcons[variant]}
          </span>
          {message}
        </span>
      }
      action={
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          //className={classes.close}
          onClick={onClose}
        >
          <span className="material-icons md-24">close</span>
        </IconButton>
      }
      {...other}
    />
  )
}

const SystemMessageSnackbarContentWrapper = withStyles(systemMessageStyles)(
  SystemMessageSnackbarContent
)

class SystemMessageSnackbar extends React.Component {
  state = {
    open: false,
    messageInfo: {}
  }

  queue = []

  componentWillReceiveProps = nextProps => {
    if (
      nextProps.systemMessage.timestamp !== this.props.systemMessage.timestamp
    ) {
      this.queue.push({
        systemMessage: nextProps.systemMessage.message,
        type: nextProps.systemMessage.type,
        duration: nextProps.systemMessage.duration,
        key: nextProps.systemMessage.timestamp
      })

      if (this.state.open) {
        // immediately begin dismissing current message
        // to start showing new one
        this.setState({ open: false })
      } else {
        this.processQueue()
      }
    }
  }

  processQueue = () => {
    if (this.queue.length > 0) {
      this.setState({
        messageInfo: this.queue.shift(),
        open: true
      })
    }
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.setState({ open: false })
  }

  handleExited = () => {
    this.processQueue()
  }

  render() {
    const { systemMessage, type, duration } = this.state.messageInfo
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          open={this.state.open}
          autoHideDuration={duration}
          onClose={this.handleClose}
          onExited={this.handleExited}
          ContentProps={{
            'aria-describedby': 'message-id'
          }}
        >
          <SystemMessageSnackbarContentWrapper
            onClose={this.handleClose}
            variant={type}
            message={<span id="message-id">{systemMessage}</span>}
          />
        </Snackbar>
      </div>
    )
  }
}

export default SystemMessageSnackbar



// WEBPACK FOOTER //
// ./src/Components/SystemMessageSnackbar.js